export default "__VITE_ASSET__CbKyQf8W__"